import CompanySuspendedBanner from './CompanySuspendedBanner';
import DeliveryPaymentBlockBanner from './DeliveryPaymentBlockBanner';
import NoFranchiseBanner from './NoFranchiseBanner';
import NotificationsDropdown from './NotificationsDropdown';
import PartnerPayoutAccountBanner from './PartnerPayoutAccountBanner';
import PaymentGatewayKycBanner from './PaymentGatewayKycBanner';
import ProfileDropdown from './ProfileDropdown';
import Sidebar from './Sidebar';
import StripeProcessingFeeBanner from './StripeProcessingFeeBanner';

export default {
  CompanySuspendedBanner,
  DeliveryPaymentBlockBanner,
  NoFranchiseBanner,
  NotificationsDropdown,
  PartnerPayoutAccountBanner,
  PaymentGatewayKycBanner,
  ProfileDropdown,
  Sidebar,
  StripeProcessingFeeBanner,
};
